export const INITIAL = 'INITIAL';
export const IN_PROGRESS = 'IN_PROGRESS';
export const REJECTED = 'REJECTED';
export const COMPLETED = 'COMPLETED';
export const PAYMENT_METHOD_SAVED = 'PAYMENT_METHOD_SAVED';
export const PAYMENT_DENIED = 'PAYMENT_DENIED';

